import axios from "../../../../utils/request";

function GET_LIST(params) {
  return axios.get("/member/AIconLibrary/index", {
    params: params
  });
}

function ADD(params) {
  return axios.get("/member/AIconLibrary/add", { params: {} });
}
function ADD_POST(params) {
  return axios.post("/member/AIconLibrary/addPost", { ...params });
}
function EDIT(params) {
  return axios.get("/member/AIconLibrary/edit", {
    params: {
      id: params
    }
  });
}
function EDIT_POST(params) {
  return axios.post("/member/AIconLibrary/editPost", { ...params });
}
function DELE(params) {
  return axios.post("/member/AIconLibrary/delete", {
    ids: params
  });
}

export default {
  GET_LIST,
  ADD,
  ADD_POST,
  EDIT,
  EDIT_POST,
  DELE
};
